import { MERGE_FIELDS, type MergeField } from '@/api/Rover/notifications/roverNotifications.types';
import { cx } from '../ui/primitives';

export function MergeFieldBar({
  onInsert,
  exclude = [],
  compact = false,
}: {
  onInsert: (token: string) => void;
  exclude?: MergeField[];
  compact?: boolean;
}) {
  const fields = MERGE_FIELDS.filter((f) => !exclude.includes(f));
  return (
    <div className='flex flex-wrap items-center gap-2'>
      <span className={cx('text-sm text-gray-600', !compact && 'font-semibold text-gray-700')}>
        {compact ? 'Insert:' : 'Insert merge field'}
      </span>
      {fields.map((f) => (
        <button
          key={f}
          type='button'
          // Keep focus in the text field so the token lands at the cursor.
          onMouseDown={(e) => e.preventDefault()}
          onClick={() => onInsert(`{{${f}}}`)}
          className={cx(
            'h-9 rounded-full border px-3 font-mono text-[13px]',
            'focus:outline-none focus-visible:ring-2 focus-visible:ring-emerald-600',
            f === 'selected_options'
              ? 'border-orange-300 bg-orange-50 text-orange-900'
              : 'border-gray-300 bg-white text-gray-800 hover:bg-gray-50'
          )}
        >
          {`{{${f}}}`}
        </button>
      ))}
    </div>
  );
}
